import { useState } from "react";

// One-time first-run intro, in the mental model a Splitwise user already knows:
// group -> add -> settle. Shown once (repo.seenIntro), always skippable, and
// kept in the app's own voice so the retro identity carries through.
const STEPS = [
  {
    title: "Make or join a group",
    body: "A group is a shared khata: a trip, a flat, a dinner out. Start one and invite friends with a link or a QR code, or join theirs.",
  },
  {
    title: "Add what everyone spent",
    body: "Log who paid and who it was for. PaisaSplit works out each person's share, equally or by exact amounts, and keeps a running tally.",
  },
  {
    title: "Settle up",
    body: "See who owes whom at a glance and pay in one tap over UPI. Every entry is signed on your phone, so nothing can be quietly rewritten.",
  },
];

export function Walkthrough({ onDone }: { onDone: () => void }) {
  const [step, setStep] = useState(0);
  const current = STEPS[step];
  if (!current) return null;
  const last = step === STEPS.length - 1;

  return (
    <div className="page center">
      <h1 className="brand">PaisaSplit</h1>
      <div className="card">
        <div className="fineprint">
          {step + 1} of {STEPS.length}
        </div>
        <h2>{current.title}</h2>
        <p className="tagline">{current.body}</p>
        <div className="row gap">
          <button className="btn primary" onClick={() => (last ? onDone() : setStep((i) => i + 1))}>
            {last ? "Get started" : "Next"}
          </button>
          {!last && (
            <button className="btn link" onClick={onDone}>
              Skip
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
